module.exports = __webpack_public_path__ + "img/dq_pic_outlier_historical.ad3a2689.png";